var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasActivityContent)?_c('div',{staticClass:"activity-message-wrap"},[_c('div',{staticClass:"activity-content text-xs text-center py-2 px-3 my-2 mx-auto rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"},[_vm._v("\n    "+_vm._s(_vm.formattedContent)+"\n  ")])]):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }